module.exports = "\n<div style=\"padding-top: 0px\">\n  <div style=\"background-image: url('/assets/images/avalancheType.jpg'); text-align:center\" class=\"bannerImage img-responsive\" >\n    <button class=\"btn btn-lg btn-danger\" style=\"margin-top: 80px;\">Login</button>\n\n  </div>\n</div>\n<div style=\"text-align:center\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/main/main.html
// module id = 51
// module chunks = 0